import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../Header/Header';
import './Main.css';
import background from "../../assets/images/AboutusBackgroud.png";
import Aboutpoto1 from '../../assets/images/Aboutpoto1.png';
import Aboutpoto2 from '../../assets/images/Aboutpoto2.png';
import Vazi3 from '../../assets/images/Vazi3.png';
import Italyimg from '../../assets/images/italyimg.png';
import Service from '../../assets/images/service-end.png';
import Photocollage from '../Main/collage/photocollage';
import ServiceComponent from './ServiceInfo/ServiceComponent';
import VideoPlayer2 from '../../Video/video2';
// import VideoPlayer from '../../Video/video';

function Main() {
  const [expandedHeight, setExpandedHeigth] = useState(0);
  
  const { t, i18n } = useTranslation();
  const languageClass = i18n.language === "ka" ? "georgian" : "english"; 

  return (
    <div className={`main-page ${languageClass}`}>
      <Header />
      <div className={`maincontainer ${languageClass}`} style={{ marginBottom: expandedHeight }}>
        <div className={`bbb ${languageClass}`} id='/about'> 
          <div id='about' className={`back ${languageClass}`} style={{ backgroundImage: `url(${background})` }}>  
            <h1>{t('About us')}</h1>
            <div className={`aboutpoto1 ${languageClass}`}>
              <img src={Aboutpoto1} alt='aboutpoto1'/>
              <p>{t('CE Enologica is an esteemed Italian company that has been dedicated to supporting the art of winemaking for a decade in Georgia.')}</p>
            </div>
            <div className={`aboutpoto2 ${languageClass}`}>
              <img src={Aboutpoto2} alt='Aboutphoto2'/>
              <p>{t('With a foundation built on extensive experience and a profound passion for viticulture, we pride ourselves on standing shoulder-to-shoulder with Georgian winemakers.')}</p>
            </div>
          </div>
        </div>

        <div className={`vaziphotos ${languageClass}`}>
          <div className={`vazi3 ${languageClass}`} style={{ backgroundImage: `url(${Vazi3})` }}></div>
        </div>

        <div id="/service" className={`service-info ${languageClass}`}>
          <h1>{t('Service')}</h1>
          <div className={`service-logos ${languageClass}`}>
            <ServiceComponent />
          </div>
        </div>

        <div className={`service-end ${languageClass}`} style={{ backgroundImage: `url(${Service})` }}>
          <p>{t('CE Enologica offers top quality equipment for winemaking and viticulture, ensuring the top notch quality of your final product. In partnership with Bucher Vaslin, Pompa Francesca, Rodina Haskovo, DES Subotica and other leading brands we guarantee the best tools in order for you to excel in the art of wine.')}</p>
        </div>

       
        <div className={`italyimg ${languageClass}`} style={{ backgroundImage: `url(${Italyimg})` }}>
          <div className={`italyimg-text ${languageClass}`}>
            <p>{t('OUR LONG WEEK-END')}</p>
            <p>{t('TO TUSCANY')}</p>
          </div>
        </div>

        <div className={`photocolage ${languageClass}`}>
          <Photocollage />
        </div>

        <VideoPlayer2 className={`main-video ${languageClass}`} />
      </div>
    </div>
  );
}

export default Main;
